export const suppressUseLayoutEffectWarning = (callback) => {
  const originalError = console.error;

  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes(
        'useLayoutEffect does nothing on the server'
      )
    ) {
      return;
    }

    originalError(...args);
  };

  try {
    return callback();
  } finally {
    console.error = originalError;
  }
};
